// extracted by mini-css-extract-plugin
export var active = "_e6-2";
export var recordingDot = "_e6-1";
export var recordingIndicator = "_e6-0";